/**
 * PAPPO — Contacts Service
 * Comunicação com a API de contactos (/api/contacts).
 */

import { apiGet, apiPost, apiPut, apiDelete } from './api';
import type { Contact } from '../types/user';

export interface ContactsData {
  contacts: Contact[];
  pending_incoming: Contact[];
}

/** Lista contactos do utilizador + pedidos recebidos pendentes */
export async function listContacts() {
  return apiGet<ContactsData>('/contacts');
}

/** Envia um pedido de contacto por username */
export async function requestContact(username: string) {
  return apiPost<{ accepted?: boolean; pending_guardian_approval?: boolean }>(
    '/contacts',
    { username }
  );
}

/** Aceita um pedido de contacto recebido (id da linha) */
export async function acceptContact(id: number) {
  return apiPost<{ ok?: boolean }>(`/contacts/${id}/accept`);
}

/** Remove ou rejeita um contacto (id da linha) */
export async function removeContact(id: number) {
  return apiDelete<{ ok?: boolean }>(`/contacts/${id}`);
}

/**
 * Define/atualiza o apelido LOCAL para um utilizador (targetId = id do
 * utilizador-alvo). Apelido vazio remove-o. Só o dono o vê.
 */
export async function setAlias(targetId: number, alias: string) {
  const value = alias.trim();
  if (!value) {
    return apiDelete<{ alias: null }>(`/contacts/${targetId}/alias`);
  }
  return apiPut<{ alias: string }>(`/contacts/${targetId}/alias`, {
    alias: value,
  });
}

/** Arquiva a conversa 1:1 com o utilizador-alvo (per-user, só visual) */
export async function archiveWith(targetId: number) {
  return apiPost<{ archived: boolean; conversation_id: number }>(
    `/contacts/${targetId}/archive`
  );
}

/** Desarquiva a conversa 1:1 com o utilizador-alvo */
export async function unarchiveWith(targetId: number) {
  return apiDelete<{ archived: boolean; conversation_id: number }>(
    `/contacts/${targetId}/archive`
  );
}
